import React from "react";
import { AlertTriangle, CalendarClock } from "lucide-react";
import moment from "moment";

export default function SymbolCard({ item }) {
  return (
    <div className="bg-[var(--background)] mt-2 border-2 border-[var(--hover)] rounded-xl p-4 mb-3 transition-all duration-300">
      {/* Header Section */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className="p-2 rounded-full border-2 border-[var(--sellmeta)] bg-[var(--background)]/15 text-[var(--hover)]">
            <AlertTriangle className="text-[var(--sellmeta)]" size={18} />
          </div>
          <h2 className="text-[var(--text)] font-semibold text-base">
            {item.symbol || "Unknown Symbol"}
          </h2>
        </div>
        <span className="text-xs px-2 py-1 rounded-md bg-[var(--hover)]/10 text-[var(--hover)] font-medium">
          {item.type?.toUpperCase() || "N/A"}
        </span>
      </div>

      {/* Middle Info Section */}
      <div className="grid  grid-cols-2 md:grid-cols-3 gap-y-2 mt-2 text-sm">
        <InfoRow label="Reason" value={item.msg || "No reason provided"} />
        <InfoRow label="Exchange" value={item.type || "-"} />
        <InfoRow label="Order Type" value={item.buy_sell || "-"} />
        <InfoRow label="Qty" value={item.qty || "-"} />
        <InfoRow label="Price" value={item.price ? `₹${item.price}` : "-"} />
        <InfoRow
          label="Time"
          value={moment(item.created_at).format("DD MMM, hh:mm A")}
        />
      </div>

      {/* Footer Section */}
      <div className="flex items-center justify-end mt-3 text-[var(--muted)] text-xs">
        <CalendarClock size={13} className="mr-1" />
        <span>Logged on {moment(item.created_at).format("DD MMM YYYY")}</span>
      </div>
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex flex-col">
      <span className="text-[var(--text)] text-[11px] uppercase tracking-wide">
        {label}
      </span>
      <span className="text-[var(--text)] font-medium">{value}</span>
    </div>
  );
}
